import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'; 
import { Router } from '@angular/router'; 
import { ContractorService } from 'app/_services/contractor.service';
import { TokenStorageService } from 'app/_services/token-storage.service';

@Component({
  selector: 'app-add-contractor',
  templateUrl: './add-contractor.component.html'
})
export class AddContractorComponent implements OnInit {
  addContractorForm: FormGroup = new FormGroup({
    company_name: new FormControl(""),
    contact_name: new FormControl(""),
    gender: new FormControl(""),
    phone: new FormControl(""),
    mobile: new FormControl(""),
    fax: new FormControl(""),
    email: new FormControl(""),
    address: new FormControl(""),
    address2: new FormControl(""),
    postalcode: new FormControl(""),
    city: new FormControl(""),
    province: new FormControl(""),
    country: new FormControl("")
  });

  constructor(
    private http: HttpClient,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private contractor: ContractorService,
  ) { }

  ngOnInit(): void {
  }

  onSubmit(values: any): void {
    const contactUUID = this.tokenStorage.getToken() || "";

    let contractorInfo: any = {
      company_name: values.company_name,
      contact_name: values.contact_name,
      gender: "N/A",
      phone: values.phone,
      mobile: values.mobile,
      fax: values.fax,
      email: values.email,
      address: values.address,
      address2: values.address2,
      postalcode: values.postalcode,
      city: values.city,
      province: values.province,
      country: values.country

    };

    this.contractor.addContractor$(contactUUID, contractorInfo).subscribe({
      next: (data: any) => {
        console.log("Data --> ", data);
        this.router.navigate(['/soustraitants']);
      },
      error: (err: any) => {
        console.log("Something went wrong: ", err.statusText)
      }
    });
  }

}
